import CloseIcon from '@mui/icons-material/Close';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import {
  Alert,
  Box,
  Typography,
  Button,
  IconButton,
  MenuItem,
  Paper,
  Grid,
  TextField,
  Dialog,
  DialogContent,
  DialogActions,
  Slide,
  FormControl,
  Select,
  DialogTitle,
  Snackbar,
  Switch,
  FormControlLabel,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { Country, State, City } from 'country-state-city';

import { useState, useEffect, useContext, useRef } from 'react';
import * as React from 'react';

import { AuthContext } from '../../contexts/auth';
import { getUsers, deleteUser, updateUserId, getUserId } from '../../services/api';
import { hasPermission, CONTEXTS, SCOPES } from '../../services/permissions'
import { UserCard } from './UserCard';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ROLE_DESCRIPTIONS = {
  visitor: 'Realiza consultas e faz comentários em obras.',
  admin: 'Cadastra obras; cria, edita e exclui fichas catalográficas e seus atributos; exclui comentários em obras; realiza consultas e faz comentários.',
  super: 'Gerencia todos os usuários do sistema (inclusive outros supers); cadastra obras; cria, edita e exclui fichas catalográficas e seus atributos; exclui comentários em obras; realiza consultas e faz comentários.',
};

function AdminUsers() {
  const { role, id } = useContext(AuthContext);
  const [searchString, setSearchString] = useState('');
  const [loadingData, setLoadingData] = useState(true);
  const [total, setTotal] = useState(0);
  const [roleFilter, setRoleFilter] = useState('');
  const debounceSearchRef = useRef(null);

  const [open, setOpen] = React.useState(false);

  const [users, setUsers] = useState([]);
  //validation
  const [errors, setErrors] = useState({});
  const [birthDate, setBirthDate] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [currentRole, setRole] = useState('');
  const [form, setForm] = useState({});
  const allCountry = Country.getAllCountries();

  const [, setLoading] = useState(false);
  const [, setName] = useState('');
  const [, setDescription] = useState('');
  const [, setInputChars] = useState([{ name: '', domain: '' }]);
  const [currentId, setCurrentId] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const [openConfirm, setOpenConfirm] = useState(false);
  const [currentDeleteId, setCurrentDeleteId] = useState("");


  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value
    })

    if (errors[field]) setErrors({
      ...errors,
      [field]: null
    })
  }


  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setCurrentDeleteId("");
  }

  const fetchUsers = async (search, pg, role) => {
    try {
      const { data } = await getUsers({ search, page: pg, limit: PER_PAGE, role });
      setUsers(data.data);
      setTotal(data.total);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    document.title = 'CEDOMCA | Lista de usuários';
    fetchUsers('', 1, '').then(() => setLoadingData(false));
  }, []);

  const handleSearchChange = (value) => {
    setSearchString(value);
    if (debounceSearchRef.current) clearTimeout(debounceSearchRef.current);
    debounceSearchRef.current = setTimeout(() => {
      setPage(1);
      fetchUsers(value, 1, roleFilter);
    }, 400);
  };

  const handleRoleFilterChange = (value) => {
    setRoleFilter(value);
    setPage(1);
    fetchUsers(searchString, 1, value);
  };

  const fetchUserId = async (id) => {
    setForm({});
    setBirthDate("");
    setCountry("");
    setCity("");
    setState("");
    setRole("");
    setCurrentId("");
    try {
      setLoading(true);
      const { data } = await getUserId(id);
      const countryObj = Country.getAllCountries().find((c) => c.name === data.country);
      const stateObj = countryObj
        ? State.getStatesOfCountry(countryObj.isoCode).find((s) => s.name === data.state)
        : null;
      setForm({ fullName: data.fullName, email: data.email });
      setBirthDate(data.birthDate ? parseISO(data.birthDate) : null);
      const cityObj = stateObj
        ? City.getCitiesOfState(countryObj.isoCode, stateObj.isoCode).find((c) => c.name === data.city)
        : null;
      setCountry(countryObj || '');
      setState(stateObj || '');
      setCity(cityObj || '');
      setRole(data.role);
      setCurrentId(id);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const handleUpdateUser = (id, event) => {
    event.preventDefault();
    fetchUserId(id);
    setOpen(true);
  };

  const handleSubmitUpdate = async (e, id) => {
    e.preventDefault();
    setLoading(true);
    const newErrors = findFormErrors()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
    } else {
      const data = {
        fullName: form.fullName,
        email: form.email,
        birthDate: birthDate,
        country: country?.name || country,
        state: state?.name || state,
        city: city?.name || city,
        role: currentRole,
        id: id,
      };
      try {
        await updateUserId(id, data);
        setForm({});
        setLoading(false);
        handleClose();
        showSnackbar('Usuário atualizado com sucesso!');
        fetchUsers(searchString, page, roleFilter);
        setCurrentId("");
      } catch (err) {
        setLoading(false);
        showSnackbar('Erro ao atualizar usuário.', 'error');
      }
    }


  };

  const handleDeleteUser = async (id, event) => {
    event.preventDefault();
    setLoading(true);
    setCurrentDeleteId("");
    setOpenConfirm(false);

    try {
      await deleteUser(id);
      setLoading(false);
      showSnackbar('Usuário excluído com sucesso!');
      fetchUsers(searchString, page, roleFilter);
    } catch (err) {
      setLoading(false);
      showSnackbar('Erro ao excluir usuário.', 'error');
    }
  };

  const handleClose = () => {
    setOpen(false);
    setName('');
    setDescription('');
    setInputChars([{ name: '', domain: '' }]);
  };

  const findFormErrors = () => {
    const { fullName, email } = form;
    const newErrors = {};
    if (!fullName || fullName === '') newErrors.fullName = 'Nome obrigatório';
    if (!email || email === '') newErrors.email = 'E-mail obrigatório';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = 'E-mail inválido';
    return newErrors;
  };


  const buildSkeletonList = () => (
    <>
      <UserCard isLoading={true} />
      <UserCard isLoading={true} />
      <UserCard isLoading={true} />
    </>
  );

  const buildUsersList = () =>
    users.map((user) => (
      <UserCard
        key={user.id}
        primary={user.fullName}
        secondary={user.email}
        role={user.role}
        location={[user.city, user.state, user.country].filter(Boolean).join(', ').replace(/, ([^,]*)$/, ' - $1')}
        onClickDelete={(event) => showConfirmDelte(user.id, event)}
        onClickUpdate={(event) => handleUpdateUser(user.id, event)}
        isHidden={!editMode || !hasPermission(role, CONTEXTS.user, SCOPES.canDelete) || (user.id == id)}
      />
    ));

  const showConfirmDelte = (index, event) => {
    event.preventDefault();
    setOpenConfirm(true);
    setCurrentDeleteId(index);
  };

  const [page, setPage] = useState(1);
  const PER_PAGE = 20;

  const totalPages = Math.ceil(total / PER_PAGE);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchUsers(searchString, newPage, roleFilter);
  };

  return (
    <div>
      <Box sx={{ maxWidth: 980, margin: 'auto', mt: 5, mb: 2, px: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h4" fontWeight="bold">
          Usuários do Sistema
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={editMode}
                onChange={(e) => setEditMode(e.target.checked)}
                sx={{
                  '& .MuiSwitch-track': { borderRadius: 12, height: 18 },
                  '& .MuiSwitch-thumb': { width: 14, height: 14 },
                  '& .MuiSwitch-switchBase': { padding: '14px' },
                  '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(16px)' },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4a9e8e', opacity: 1 },
                  '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': { color: '#fff' },
                }}
              />
            }
            label="Modo de Edição"
            labelPlacement="start"
          />
        </Box>
      </Box>

      <Box sx={{ maxWidth: 980, margin: 'auto', px: 1, display: 'flex', gap: 2, alignItems: 'flex-start' }}>
        {/* Painel de Filtros */}
        <Paper sx={{ width: '30%', flexShrink: 0, p: 2 }} elevation={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <FilterAltIcon fontSize="small" sx={{ color: 'text.secondary' }} />
            <Typography variant="subtitle1" fontWeight="bold">Filtros</Typography>
          </Box>
          <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>Buscar</Typography>
          <TextField
            fullWidth
            placeholder="Nome ou email..."
            size="small"
            value={searchString}
            InputProps={{
              startAdornment: <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />,
            }}
            variant="outlined"
            onChange={(event) => handleSearchChange(event.target.value)}
          />
          <Typography variant="body2" fontWeight="bold" sx={{ mt: 2, mb: 0.5 }}>Nível de Acesso</Typography>
          <Select
            fullWidth
            size="small"
            value={roleFilter}
            onChange={(e) => handleRoleFilterChange(e.target.value)}
            displayEmpty
          >
            <MenuItem value="">Todos os níveis</MenuItem>
            <MenuItem value="visitor">Visitante</MenuItem>
            <MenuItem value="admin">Administrador</MenuItem>
            <MenuItem value="super">Super Admin</MenuItem>
          </Select>
          <Button
            fullWidth
            variant="outlined"
            sx={{ mt: 2 }}
            onClick={() => {
              setSearchString('');
              setRoleFilter('');
              setPage(1);
              fetchUsers('', 1, '');
            }}
          >
            Limpar Filtros
          </Button>
        </Paper>

        {/* Lista de usuários */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          {!loadingData && total > 0 && (
            <Box sx={{ mb: 0.5, display: 'flex', justifyContent: 'flex-start' }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {total} usuário{total !== 1 ? 's' : ''} encontrado{total !== 1 ? 's' : ''}
                {totalPages > 1 && ` (Página ${page} de ${totalPages})`}
              </Typography>
            </Box>
          )}
          <Box>
            {!loadingData && users.length === 0 && searchString === '' && (
              <Typography variant="h6" sx={{ my: 5, mx: 2 }} color="text.secondary" align="center">
                {'Nenhum usuário foi cadastrado ainda :('}
              </Typography>
            )}
            {!loadingData && users.length === 0 && searchString !== '' && (
              <Typography variant="h6" sx={{ my: 5, mx: 2 }} color="text.secondary" align="center">
                {'Nenhum usuário encontrado :('}
              </Typography>
            )}
            <Box sx={{ p: 1.5 }}>
              {loadingData ? buildSkeletonList() : buildUsersList()}
            </Box>

            <Dialog
              open={open}
              maxWidth={false}
              TransitionComponent={Transition}
              onClose={handleClose}
              PaperProps={{
                sx: { width: 480, borderRadius: 2, overflow: 'hidden' },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, pt: 3, pb: 2 }}>
                <Typography fontWeight="bold" sx={{ fontSize: '1.125rem' }}>
                  Editar Usuário
                </Typography>
                <IconButton size="small" onClick={handleClose} sx={{ color: 'text.secondary' }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>

              <DialogContent sx={{ px: 3, py: 0 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
                      Nome completo <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Digite o nome completo"
                      value={form.fullName || ''}
                      onChange={(e) => setField('fullName', e.target.value)}
                      {...(errors.fullName && { error: true, helperText: errors.fullName })}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
                      E-mail <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Digite o e-mail"
                      value={form.email || ''}
                      onChange={(e) => setField('email', e.target.value)}
                      {...(errors.email && { error: true, helperText: errors.email })}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
                      Data de nascimento <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        inputFormat="DD/MM/YYYY"
                        value={birthDate}
                        onChange={(e) => setBirthDate(e)}
                        renderInput={(params) => (
                          <TextField {...params} size="small" fullWidth placeholder="dd/mm/aaaa" />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
                      País <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={country}
                        displayEmpty
                        onChange={(e) => { setCountry(e.target.value); setState(''); setCity(''); }}
                      >
                        <MenuItem value=""><em>Selecione</em></MenuItem>
                        {allCountry.map((c) => (
                          <MenuItem key={c.isoCode} value={c}>{c.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
                      Estado <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={state}
                        displayEmpty
                        disabled={!country}
                        onChange={(e) => { setState(e.target.value); setCity(''); }}
                      >
                        <MenuItem value=""><em>Selecione</em></MenuItem>
                        {State.getStatesOfCountry(country?.isoCode).map((s) => (
                          <MenuItem key={s.isoCode} value={s}>{s.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
                      Cidade <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={city}
                        displayEmpty
                        disabled={!state}
                        onChange={(e) => setCity(e.target.value)}
                      >
                        <MenuItem value=""><em>Selecione</em></MenuItem>
                        {City.getCitiesOfState(country?.isoCode, state?.isoCode).map((c) => (
                          <MenuItem key={c.name} value={c}>{c.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sx={{ mb: 1 }}>
                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 0.5 }}>
                      Papel do usuário <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={currentRole}
                        onChange={(e) => setRole(e.target.value)}
                      >
                        <MenuItem value="visitor">Visitante</MenuItem>
                        <MenuItem value="admin">Administrador</MenuItem>
                        <MenuItem value="super">Super Admin</MenuItem>
                      </Select>
                    </FormControl>
                    {currentRole && (
                      <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5, display: 'block' }}>
                        • {ROLE_DESCRIPTIONS[currentRole]}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </DialogContent>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, px: 3, py: 2.5 }}>
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  sx={{ borderColor: '#bdbdbd', color: 'text.primary' }}
                >
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  onClick={(event) => handleSubmitUpdate(event, currentId)}
                  sx={{ bgcolor: '#4a9e8e', color: '#fff', boxShadow: 'none', '&:hover': { bgcolor: '#3a8070', boxShadow: 'none' } }}
                >
                  Salvar Alterações
                </Button>
              </Box>
            </Dialog>
            <Dialog
              onBackdropClick="false"
              open={openConfirm}
              TransitionComponent={Transition}
              keepMounted
              onClose={handleClose}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{"Deseja excluir este usuário?"}</DialogTitle>
              <DialogContent />
              <DialogActions>
                <Button onClick={handleCloseConfirm}>Cancelar</Button>
                <Button onClick={(event) => handleDeleteUser(currentDeleteId, event)} color="error">Excluir</Button>
              </DialogActions>
            </Dialog>
            {!loadingData && totalPages > 1 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
                <Button
                  variant="outlined"
                  disabled={page <= 1}
                  onClick={() => handlePageChange(page - 1)}
                  sx={{ borderColor: '#bdbdbd', color: '#555' }}
                >
                  &lt; Anterior
                </Button>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Página {page} de {totalPages}
                </Typography>
                <Button
                  variant="outlined"
                  disabled={page >= totalPages}
                  onClick={() => handlePageChange(page + 1)}
                  sx={{ borderColor: '#bdbdbd', color: '#555' }}
                >
                  Próximo &gt;
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" elevation={6} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
export default AdminUsers;
